import { read } from "./read"

export const swUserProfile = {
  read,
}
